import React, { forwardRef } from 'react';
import Box from 'components/Box';
var TextPlaceholder = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 200 : _ref$width;
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    as: "span",
    display: "block",
    width: width,
    maxWidth: "100%",
    height: "1lh",
    backgroundColor: "shaded"
  }, children);
});
TextPlaceholder.displayName = 'TextPlaceholder';
export default TextPlaceholder;